import { HttpClient } from '@angular/common/http';
import { APIBaseManager } from '../../api.base';
import { IPluginInstance } from './api.plugin.data';

export class APIListPluginInstanceManager extends APIBaseManager<void, void, void, { itemList: IPluginInstance[], limit: number, skip: number, total: number }> {
    constructor(protected http: HttpClient) {
        super(http);
        this._apiName = 'API_ListPluginInstance';
        this._apiMethod = 'GET';
        this._allowPayloadPrint = false;
    }

    protected getRequestURL(pathParameters: void, queryParameters: void): string {
        return super.getRequestURL() + 'pluginInstances';
    }
}